import React from "react";
import { useLang } from "../../context/LanguageContext";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  const { t } = useLang();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/20499528/pexels-photo-20499528.jpeg"
          alt="wedding"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C] via-[#0A0A0C]/85 to-[#0A0A0C]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-24 md:pt-40 pb-32">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-8 animate-fade-in-up">
            {t("hero.overline")}
          </div>
          <h1 className="font-display font-light text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tighter text-white leading-[0.95] animate-fade-in-up" style={{ animationDelay: '120ms' }}>
            {t("hero.title_1")}
            <br />
            <em className="italic gold-shimmer">{t("hero.title_2")}</em>
          </h1>
          <p className="mt-10 text-base md:text-lg text-white/70 max-w-xl leading-relaxed animate-fade-in-up" style={{ animationDelay: '240ms' }}>
            {t("hero.subtitle")}
          </p>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 animate-fade-in-up" style={{ animationDelay: '360ms' }}>
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("contact")}
              className="group bg-[#D4AF37] text-[#0A0A0C] hover:bg-[#C5A059] px-10 py-5 uppercase tracking-[0.25em] text-xs font-bold transition-colors inline-flex items-center justify-center gap-3"
            >
              {t("hero.cta_primary")}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("services")}
              className="border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10 px-10 py-5 uppercase tracking-[0.25em] text-xs font-bold transition-colors"
            >
              {t("hero.cta_secondary")}
            </button>
          </div>
        </div>
      </div>

      {/* Decorative gold line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />
    </section>
  );
};

export default Hero;
